import { Component } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import { del } from "shared/lib/api"

export default class Feedback extends Component {
  constructor(props) {
    super(props)
    this.state = {
      feedback: this.props.values,
      fromReviewTeam: this.props.values.from_review_team,
    }
    this.dismissFeedback = this.dismissFeedback.bind(this)
    this.onFeedbackUpdated = this.props.onFeedbackUpdated
  }

  dismissFeedback() {
    let warning = window.confirm("Are you sure you want to delete this comment? This cannot be undone.")

    if (warning) {
      del(`/services/${this.props.service.slug}/feedbacks/${this.props.index}`, {
        feedback_path: this.props.pathObjs,
      }).then(response => this.onFeedbackUpdated(response))
    }
  }

  render() {
    const classNames = "feedback-item"
    const username = this.state.fromReviewTeam
      ? `Review Team (${this.state.feedback.username})`
      : this.state.feedback.username
    return (
      <div className={classNames}>
        {!this.props.preview ? <span className="dismiss" onClick={this.dismissFeedback} /> : null}
        <div className="feedback-text">{this.state.feedback.feedback}</div>
        <div className="name">{username}</div>
        <div className="timestamp">
          {moment(new Date(this.state.feedback.time).toISOString()).format("MMMM Do YYYY, h:mm:ss a")}
        </div>
      </div>
    )
  }
}

Feedback.propTypes = {
  service: PropTypes.object,
  values: PropTypes.object,
  pathObjs: PropTypes.array,
  preview: PropTypes.bool,
  index: PropTypes.number,
  onFeedbackUpdated: PropTypes.func,
}
